import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createComponentGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { RequireProExitWorkspace } from './components/require-pro-exit-workspace'

function guarded(Page: ComponentType): ComponentType {
  return createComponentGuardedPage(RequireProExitWorkspace, Page)
}

export const proExitRoutes: RouteObject[] = [
  {
    path: 'pro/exit',
    lazy: async () => {
      const { ProExitHubPage } = await import('./pages/pro-exit-hub-page')
      return { Component: guarded(ProExitHubPage) }
    },
  },
  {
    path: 'pro/exit/cases/:caseId',
    lazy: async () => {
      const { ProExitCasePage } = await import('./pages/pro-exit-case-page')
      return { Component: guarded(ProExitCasePage) }
    },
  },
]
